import Cookies from 'js-cookie';

/**
 * 쿠키를 설정합니다.
 * @param {string} name - 쿠키 이름
 * @param {string} value - 쿠키 값
 */
export function setCookie(name: string, value: string) {
  Cookies.set(name, value, {
    domain: process.env.REACT_APP_COOKIE_DOMAIN,
    expires: 1, // 1년짜리 영구쿠키
  });
}

/**
 * 쿠키 값을 가져옵니다.
 * @param {string} name - 쿠키 이름
 * @returns {string | undefined} - 쿠키 값 (없으면 undefined)
 */
export function getCookie(name: string): string | undefined {
  return Cookies.get(name);
}

/**
 * 쿠키를 삭제합니다.
 * @param {string} name - 쿠키 이름
 * @param {Cookies.CookieAttributes} [options] - 쿠키 옵션 (path, domain 등)
 */
export function deleteCookie(name: string) {
  Cookies.remove(name, {
    domain: process.env.REACT_APP_COOKIE_DOMAIN,
  });
}
